/**
 * Carousel tools.
 */
H_Tools.carousel = (() => {
    // console.log('Carousel tools initialized...);

    function addListeners(splide, splideElement) {
        let liveRegion = splideElement.querySelector('.live_region');

        if (!liveRegion) {
            return;
        }

        // Update live region when carousel rotates
        splide.on('moved', function (newIndex) {
            liveRegion.textContent =
                liveRegion.getAttribute('data-label-showing') +
                ' ' +
                (newIndex + 1) +
                ' - ' +
                (newIndex + splide.options.perPage);
        });
    }

    function getLabels(splideElement) {
        return {
            prev: splideElement.getAttribute('data-label-prev'),
            next: splideElement.getAttribute('data-label-next'),
            first: splideElement.getAttribute('data-label-first'),
            last: splideElement.getAttribute('data-label-last'),
            slideX: splideElement.getAttribute('data-label-slideX'),
            pageX: splideElement.getAttribute('data-label-pageX'),
            carousel: splideElement.getAttribute('data-label-carousel'),
            select: splideElement.getAttribute('data-label-select'),
            slide: splideElement.getAttribute('data-label-slide'),
            slideLabel: '%s / %s',
        };
    }

    // Return an object to expose inner functions
    return {
        addListeners: addListeners,
        getLabels: getLabels,
    };
})();
